import { useMemo } from "react";
import Autoplay from "embla-carousel-autoplay";
import { Carousel, CarouselContent, CarouselItem } from "@/components/ui/carousel";
import { useDisplay } from "@/lib/display";

export const AutoRail = ({ section, items, render, gap = "gap-5", mobileCols = "sm:grid-cols-2", slideBasis = "basis-[85%] sm:basis-1/2" }) => {
  const s = useDisplay(section);
  const plugins = useMemo(() => (s?.auto ? [Autoplay({ delay: s.seconds * 1000, stopOnInteraction: false, stopOnMouseEnter: true })] : []), [s]);
  if (!s) return null;
  const vars = { "--cols": s.count };

  if (!s.auto) {
    return (
      <div className={`grid ${gap} ${mobileCols} lg:[grid-template-columns:repeat(var(--cols),minmax(0,1fr))]`} style={vars} data-testid={`${section}-grid`}>
        {items.map((it, i) => render(it, i))}
      </div>
    );
  }
  return (
    <Carousel opts={{ loop: true, align: "start" }} plugins={plugins} style={vars} data-testid={`${section}-carousel`}>
      <CarouselContent>
        {items.map((it, i) => (
          <CarouselItem key={i} className={`${slideBasis} lg:basis-[calc(100%/var(--cols))]`}>{render(it, i)}</CarouselItem>
        ))}
      </CarouselContent>
    </Carousel>
  );
};
